'use client';

import { useRouter } from 'next/navigation';
import { ChevronsRight } from 'lucide-react';
import { StoriesWithDetailEyecatches } from '@/types/stories';
import IconAdaptive from '@/components/IconAdaptive';
import RectButton from '@/components/RectButton';
import SectionDecoratedTitle from '@/components/SectionDecoratedTitle';
import StoriesListUnit from '@/(routers)/stories/list/components/unit/StoriesListUnit';

export interface TopStoriesProps {
    stories: StoriesWithDetailEyecatches[];
}

export default function TopStories({ stories }: TopStoriesProps) {
    const router = useRouter();

    const goToStories = () => {
        router.push('/stories');
    };

    return (
        <div className="flex flex-col justify-center items-center w-full pt-8 px-0 md:px-8">
            <div className="flex justify-center items-start w-full md:w-[98%] rounded-none md:rounded-3xl bg-color-white-base pt-8 px-8 pb-16">
                <div className="w-full md:w-[98%] lg:w-[85%] rounded-3xl">
                    <div className="flex w-full justify-start relative">
                        <div className="w-full pb-12">
                            <SectionDecoratedTitle title="STORIES" subTitle="スクーミーの事例を紹介" />
                        </div>
                        <div
                            className="absolute right-0 top-6 md:flex flex-grow justify-end items-center font-notojp font-bold text-color-base text-sm lg:text-base cursor-pointer hidden md:block"
                            onClick={goToStories}
                        >
                            <IconAdaptive
                                Icon={ChevronsRight}
                                baseSize={22}
                                breakpoints={{ md: 24 }}
                                className="mt-[2px]"
                            />
                            もっとみる
                        </div>
                    </div>
                    {stories.length > 0 && (
                        <>
                            <div className="w-full mx-auto">
                                {stories.map((data, index) => (
                                    <div key={data.id} className={index === stories.length - 1 ? '' : 'pb-20'}>
                                        <StoriesListUnit data={data} showMoreButton={false} />
                                    </div>
                                ))}
                            </div>
                            <div className="flex justify-center w-full py-8 md:hidden">
                                <RectButton label={'もっとみる'} width={'80%'} onClick={goToStories} />
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
}
